<template>
  <RatioBox :ratio="ratio" style="background: #000">
    <video
      ref="nativeVideo"
      webkit-playsinline
      playsinline
      allowsInlineMediaPlayback
      :src="src"
      :controls="showControls"
      :auto-play="autoPlay"
      @play="playing = true"
      @pause="playing = false"
      @seeking="seeking = true"
      @seeked="handlePlay"
      style="width: 100%; height: 100%"
      :style="videoObjectFit"
    ></video>
    <div class="play-mask" v-show="!showControls">
      <div class="play-btn" @click="handlePlay"></div>
    </div>
  </RatioBox>
</template>
<script>
import RatioBox from '@/components/behavior/ratio-box/index.vue'

// 等比例video组件
// Q: 为什么视频是等比例的还写这个？
// A: 视频未loadedmeta时，比例不一定是需要的
export default {
  name: 'VideoPlayer',
  props: {
    ratio: {
      type: Number,
      default: 16 / 9,
    },
    src: {
      type: String,
      required: true,
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    objectFit: {
      // image style的object-fit
      type: String,
      default: null,
      validator(value) {
        return ['fill', 'contain', 'cover', 'none', 'scale-down'].includes(
          value
        )
      },
    },
  },
  components: {
    RatioBox,
  },
  data() {
    return {
      playing: false,
      seeking: false
    }
  },
  beforeDestroy() {
    const video = this.nativeVideo
    video.src = ''
    video.pause()

    this.unwatch()
    this.unwatch = null
  },
  mounted() {
    this.$nextTick(() => {
      this.unwatch = this.$watch('src', () => {
        const video = this.nativeVideo
        video.pause()
        this.$nextTick(() => {
          video.currentTime = 0
          video.play()
        })
      })
    })
  },
  computed: {
    nativeVideo() {
      return this.$refs.nativeVideo
    },
    videoObjectFit() {
      let objectFit = this.objectFit
      if (objectFit === null) {
        objectFit = this.playing ? 'contain' : 'fill'
      }
      return `object-fit: ${objectFit}`
    },
    showControls() {
      return this.seeking || this.playing
    }
  },
  methods: {
    handlePlay() {
      this.nativeVideo.play().then(() => {
        this.seeking = false
      })
    },
  },
}
</script>
<style lang="less" scoped>
.play-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(10, 15, 26, 0.2);
  z-index: 2;
}
.play-btn {
  position: absolute;
  width: 36px;
  height: 36px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: url(~@/assets/play-btn.svg) center / cover no-repeat;
  cursor: pointer;
}
</style>
